export enum ToastType {
  Success = 'green',
  Error = 'red',
  Warning = 'yellow',
}
